import { useTranslation } from "react-i18next";

export const useIsPersian = () => {
  const { i18n } = useTranslation();
  return i18n.language === "fa";
};
